export default {"src":"/_next/static/image/public/images/ic_bookmark_dark_grey.4facc6e829a2c1d670f54dee40a6bbb9.svg","height":18,"width":14};